import Icon from '../components/Icon.vue'

Icon.register({
  deaf: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M216 260c0 15.5-12.5 28-28 28s-28-12.5-28-28c0-44.1 35.9-80 80-80s80 35.9 80 80c0 15.5-12.5 28-28 28s-28-12.5-28-28c0-13.2-10.8-24-24-24s-24 10.8-24 24zM240 84c97 0 176 79 176 176 0 96-71.4 109.8-72 144.2-0.1 59.4-48.5 107.8-108 107.8-15.5 0-28-12.5-28-28s12.5-28 28-28c28.7 0 52-23.3 52-52l0-0.4c1-73.3 72-68.5 72-143.6 0-66.2-53.8-120-120-120s-120 53.8-120 120c0 15.5-12.5 28-28 28s-28-12.5-28-28c0-97 79-176 176-176zM508.5 31.8c4.7 4.7 4.7 12.3 0 17l-87 87c-4.7 4.7-12.3 4.7-17 0l-28.3-28.3c-4.7-4.7-4.7-12.3 0-17l87-87c4.7-4.7 12.3-4.7 17 0zM169 314.7l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-148.5 148.5c-4.7 4.7-12.3 4.7-17 0l-28.3-28.3c-4.7-4.7-4.7-12.3 0-17l148.5-148.5c4.7-4.7 12.3-4.7 17 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/deaf.js
// module id = 1253
// module chunks = 0